export default "/images/8b5ec4a679c38af52724391a145f2871.png";